import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Typography } from '@mui/material';
import Grid from 'material/components/Grid';

import { colors } from 'utils/constants';
import ColorPicker from 'common/components/ColorPicker';

const ColorPickerTitle = styled(Typography)`
  padding-right: 10px;
`;

const ColorPickerWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 10px;
  background-color: ${colors.backgroundColor};
`;

/**
 * Pair of labeled `ColorPicker` swatches for choosing a template button's
 * text and background colors. Use in template editors that expose button
 * styling; both pickers report through the single
 * `handleChangeTemplateButton` callback.
 */
const ButtonsColorsWrapper = ({
  buttonBackgroundColor,
  buttonTextColor,
  handleChangeTemplateButton,
}) => (
  <>
    <Grid alignItems="center" container justifyContent="flex-end">
      <ColorPickerTitle>Choose button text color</ColorPickerTitle>
      <ColorPickerWrapper>
        <ColorPicker
          handlePickerChange={({ hex }) => handleChangeTemplateButton('text', hex)}
          pickerColor={buttonTextColor}
        />
      </ColorPickerWrapper>
    </Grid>
    <Grid alignItems="center" container justifyContent="flex-end">
      <ColorPickerTitle>Choose button background color</ColorPickerTitle>
      <ColorPickerWrapper alignItems="center" justifyContent="flex-end">
        <ColorPicker
          handlePickerChange={({ hex }) => handleChangeTemplateButton('background', hex)}
          pickerColor={buttonBackgroundColor}
        />
      </ColorPickerWrapper>
    </Grid>
  </>
);

ButtonsColorsWrapper.propTypes = {
  buttonBackgroundColor: PropTypes.string.isRequired,
  buttonTextColor: PropTypes.string.isRequired,
  /** Called with ('text' | 'background', hexColor) when either picker changes. */
  handleChangeTemplateButton: PropTypes.func.isRequired,
};

export default ButtonsColorsWrapper;
